import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { GlobalButton, TextInput, DateInput } from '@/components';
import { useState, useEffect } from 'react';
import {
  Search as SearchIcon,
  DeleteForever as TrashIcon,
} from '@mui/icons-material';
import type { AmendmentsFilter } from '../../models';

interface AmendmentsSearchBarProps {
  filter: AmendmentsFilter;
  onSearch: (filter: AmendmentsFilter) => void;
}

const EMPTY_FILTER: AmendmentsFilter = {
  shippingNumber: '',
  transitionId: '',
  from: null,
  to: null,
};

const AmendmentsSearchBar = ({ filter, onSearch }: AmendmentsSearchBarProps) => {
  const [localFilter, setLocalFilter] = useState<AmendmentsFilter>(filter);

  useEffect(() => {
    setLocalFilter(filter);
  }, [filter]);

  const update = (patch: Partial<AmendmentsFilter>) =>
    setLocalFilter((prev) => ({ ...prev, ...patch }));

  const handleReset = () => {
    setLocalFilter(EMPTY_FILTER);
    onSearch(EMPTY_FILTER);
  };

  return (
    <div className='w-full p-5 flex flex-col justify-center bg-white rounded-sm shadow-xl gap-5'>
      <span className='text-[13px] font-bold text-gray-400 uppercase tracking-widest'>
        Filtros de búsqueda
      </span>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-3'>
        <TextInput
          name='amendment-shipping-number-filter'
          placeholder='ID Pedido'
          value={localFilter.shippingNumber || ''}
          onChange={(value) => update({ shippingNumber: value.toString() })}
          type='number'
        />
        <DateInput
          name='amendment-from-filter'
          placeholder='Desde'
          value={localFilter.from || null}
          onChange={(date) => update({ from: date })}
        />
        <DateInput
          name='amendment-to-filter'
          placeholder='Hasta'
          value={localFilter.to || null}
          onChange={(date) => update({ to: date })}
        />
      </div>
      <div className='flex gap-3 justify-end'>
        <GlobalButton variant={GlobalButtonVariant.secondaryButton} action={handleReset}>
          <TrashIcon color='primary' />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => onSearch(localFilter)}
          size='large'
        >
          <SearchIcon />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default AmendmentsSearchBar;
